import { CapacitorUpdater } from '@capgo/capacitor-updater';
import ReactDOM from 'react-dom/client';
import { App } from './pages/_app';

CapacitorUpdater.notifyAppReady();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(<App />);
